export default "__VITE_ASSET__527d7153__"